import { Home, WorkDetail, Works, Contact, Studio } from "../containers";
import Terma from "../containers/Experiment/terma.tsx";

export const routes = [
  {
    title: "Home",
    path: "*",
    component: <Home route={""} />,
    protected: false,
  },
  {
    title: "Workdetail",
    path: "/work/:slug",
    component: <WorkDetail route={""} />,
    protected: false,
  },
  {
    title: "Works",
    path: "/works",
    component: <Works route={""} />,
    protected: false,
  },
  {
    title: "Studio",
    path: "/studio",
    component: <Studio route={""} />,
    protected: false,
  },
  {
    title: "Contact",
    path: "/contact",
    component: <Contact route={""} />,
    protected: false,
  },

  {
    title: "Experiment/Terma",
    path: "/experiment/terma",
    component: <Terma route={""} />,
    protected: false,
  },
];
